import { initializeApp } from "firebase/app";
import { getFirestore, connectFirestoreEmulator } from "firebase/firestore";
import { getAuth, connectAuthEmulator } from "firebase/auth";

const firebaseConfig = {
  apiKey: "demo", // ok for Firestore usage; for Auth later you’ll want real config
  authDomain: "stuttgart-stage2-dev.firebaseapp.com",
  projectId: "stuttgart-stage2-dev",
};

const app = initializeApp(firebaseConfig);

console.log("🔥 firebase projectId =", app.options.projectId);

export const db = getFirestore(app);
export const auth = getAuth(app);

// ✅ Emulator is opt-in ONLY
const useEmulators = process.env.REACT_APP_USE_EMULATORS === "1";

if (useEmulators) {
  console.log("🔥 Using Firebase EMULATORS");
  connectFirestoreEmulator(db, "127.0.0.1", 8085);
  connectAuthEmulator(auth, "http://127.0.0.1:9095");
} else {
  console.log("✅ Using LIVE Firebase (no emulators)");
}